const NECH_FORM_ITEM_INIT = 'nech-form-item-init';
(function (Drupal, once, $) {
  $('.js-form-item')
    .not('.' + NECH_FORM_ITEM_INIT)
    .each((i, el) => {});
})(Drupal, once, jQuery);
